import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { compose } from 'redux';
import connectSaga from 'utils/saga';
import saga from 'screens/Balance/saga';
import { selectState } from 'utils/reduxActions';
// ui
import { Card, CardContent, CircularProgress, Container } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Filters from 'screens/Balance/components/Filters';
import InfoForm from 'screens/Balance/components/InfoForm';
import { getLocalDate } from 'utils/DateFormat';
import { getUnitDetails } from 'utils/functions';
import { FirstTable } from './FirstTable';
import { useTranslation } from 'react-i18next';

const getLotState = (lot) => {
  let status = '';
  if (lot.warehouseId && lot.price === null && lot.destinyProcessId === null) {
    status = 'En bodega';
  } else if (lot.price !== null) {
    status = 'Despachado';
  } else if (lot.destinyProcessId !== null && lot.price === null) {
    status = 'Procesado';
  } else if (lot.destinyProcessId === null && lot.warehouseId === null) {
    status = 'Procesado sin destino';
  }
  return status;
};

const getLotTable = (lotsFiltered, objects, t) => {
  const { unitCode, unitName } = getUnitDetails(objects.accounts);

  const title = `DISTRIBUCIÓN TOTAL DE ${unitName.toUpperCase()} EN PAK (TRAZABILIDAD)`;
  const headers = [
    t('balance.lotTable.headers.process'),
    t('balance.lotTable.headers.lot'),
    t('balance.lotTable.headers.state'),
    t('balance.lotTable.headers.date'),
    t('balance.lotTable.headers.client'),
    t('balance.lotTable.headers.product'),
    t('balance.lotTable.headers.packagingType'),
    `${unitName}`,
  ];
  const rows = [];
  let totalLotsWeight = 0;
  lotsFiltered?.map((lot) => {
    if (getLotState(lot) === 'Despachado') {
      totalLotsWeight += lot.quantity;
      rows.push([
        lot.originProcessId,
        lot.id,
        'Despachado',
        getLocalDate(new Date(lot.destinyProcess?.date)).localeDate,
        lot.destinyProcess.Dispatch.Client.Entity.name,
        lot.Product.name,
        lot.PackagingType.name,
        lot.quantity,
      ]);
    } else if (getLotState(lot) === 'En bodega') {
      totalLotsWeight += lot.quantity;
      rows.push([
        lot.originProcessId,
        lot.id,
        'En bodega',
        '-',
        '-',
        lot.Product.name,
        lot.PackagingType.name,
        lot.quantity,
      ]);
    }
  });
  const bottomText = `TOTAL ${unitName.toUpperCase()} PROCESADOS DE TARJAS SELECCIONADAS: ${Math.floor(
    totalLotsWeight,
  )
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
  return { title, headers, rows, bottomText };
};

function BalanceComponent(props) {
  const { t } = useTranslation();
  const {
    actions,
    classes,
    loading,
    info,
    defaultFilters,
    tables,
    objects,
    filteredRls,
    formControls,
  } = props;

  // @ts-ignore
  // const selectedLotsIds = useSelector((state) => state.balance.filter.lotNumber);
  const selectedLotsIds = useSelector((state) => state.balance.formControls.lotNumber);

  // @ts-ignore
  const lots = useSelector((state) => state.balance.info.lotsInfo);
  const filteredLots = lots?.filter((lot) => selectedLotsIds.includes(lot.id));
  const lotsTableInfo = getLotTable(filteredLots, objects, t);

  return (
    <Container maxWidth={false} className="container-print">
      <Grid container spacing={3} className={classes.container}>
        <Grid item xs={12}>
          <Typography variant="h3" component="h2" className={classes.marginTop}>
            {t('balance.title')}
          </Typography>
        </Grid>
        <Filters
          actions={actions}
          defaultFilters={defaultFilters}
          classes={classes}
          objects={objects}
          filteredRls={filteredRls}
        />
        {loading ? (
          <Alert severity="info">
            <Grid className={classes.alert}>
              <span style={{ marginRight: 20 }}>
                {t('balance.generatingReport')}
              </span>
              <CircularProgress size={20} thickness={5.0} />
            </Grid>
          </Alert>
        ) : tables.length === 0 ? (
          <Alert severity="info">
            <Grid className={classes.alert}>
              <span style={{ marginRight: 20 }}>{t('balance.enterLotToSearch')}</span>
            </Grid>
          </Alert>
        ) : (
          <div className="balance-container" style={{ width: '100%' }}>
            <Card id="balance-container-tables" className={`${classes.root}`}>
              <CardContent>
                <InfoForm
                  classes={classes}
                  objects={objects}
                  actions={actions}
                  filteredRls={filteredRls}
                  productorsName={tables[0].rows.map((row) => row[6])}
                  suppliers={info.suppliers}
                  varieties={tables[0].rows.map((row) => row[4])}
                  productsName={tables[0].rows.map((row) => row[3])}
                />
              </CardContent>
            </Card>

            <Card id="balance-container-tables" className={classes.root}>
              <CardContent>
                {tables.map((table, index) => (
                  <FirstTable
                    headers={table.headers}
                    rows={table.rows}
                    title={table.title}
                    bottomText={table.bottomText}
                  />
                ))}
                {filteredLots.length > 0 ? (
                  <FirstTable
                    headers={lotsTableInfo.headers}
                    rows={lotsTableInfo.rows}
                    title={lotsTableInfo.title}
                    bottomText={lotsTableInfo.bottomText}
                  />
                ) : (
                  ''
                )}
              </CardContent>
            </Card>
          </div>
        )}
      </Grid>
    </Container>
  );
}

const withSaga = connectSaga({ key: 'sagaBalance', saga });

const withConnect = connect(
  selectState('balance.tables', 'balance.info', 'balance.loading', 'balance.formControls'),
  null,
);

export default compose(withConnect)(withSaga(BalanceComponent));
